import React from 'react'

export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(result => {
      resolve(result)
    })
  })
}

export const defaultLocation = () => ({
  s: 1
})

const withLocation = WrappedComponent => {
  return class Location extends React.Component {
    state = {
      location: {
        coords: {}
      },
    }

    async componentWillMount() {
      const location = await getCurrentLocation()
      this.setState({ location })
    }

    render() {
      return <WrappedComponent {...this.props} location={this.state.location} />
    }
  }
}

export default withLocation



// WEBPACK FOOTER //
// ./src/modules/location/withLocation.js